import React from 'react';

const AUTO_RELOAD_KEY = 'gugu_auto_reload_at';
const AUTO_RELOAD_COOLDOWN_MS = 30000;

// Erro típico quando algo de fora (tradução automática do navegador, extensão) altera os textos da página
// e o React perde a referência dos elementos.
const isDomMismatch = (error) =>
  !!error && (error.name === 'NotFoundError' || /removeChild|insertBefore|not a child of this node/i.test(error.message || ''));

// Evita a "tela branca": mostra uma mensagem com botão de recarregar e, em erro de DOM alterado,
// recarrega sozinho uma vez (com intervalo mínimo para nunca entrar em laço).
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info?.componentStack);
    if (isDomMismatch(error)) {
      try {
        const last = Number(sessionStorage.getItem(AUTO_RELOAD_KEY) || 0);
        if (Date.now() - last > AUTO_RELOAD_COOLDOWN_MS) {
          sessionStorage.setItem(AUTO_RELOAD_KEY, String(Date.now()));
          window.location.reload();
        }
      } catch { /* sessionStorage indisponível: mostra a tela de erro normalmente */ }
    }
  }

  render() {
    if (!this.state.error) return this.props.children;
    const detalhe = `${this.state.error?.name || 'Erro'}: ${this.state.error?.message || ''}`.slice(0, 220);
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0f5ff', padding: 24, fontFamily: 'Manrope, system-ui, sans-serif' }}>
        <div style={{ maxWidth: 420, width: '100%', background: '#fff', borderRadius: 16, boxShadow: '0 10px 30px rgba(1,71,160,.15)', padding: 28, textAlign: 'center' }}>
          <h1 style={{ margin: '0 0 8px', fontSize: 20, color: '#0f172a' }}>Algo deu errado nesta tela</h1>
          <p style={{ margin: '0 0 20px', fontSize: 14, color: '#475569', lineHeight: 1.5 }}>
            Seus dados já salvos estão seguros. Clique no botão para recarregar o sistema e continuar.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            data-testid="btn-recarregar-erro"
            style={{ background: '#0147a0', color: '#fff', border: 0, borderRadius: 10, padding: '11px 22px', fontSize: 15, fontWeight: 700, cursor: 'pointer' }}
          >
            Recarregar o sistema
          </button>
          <p style={{ margin: '18px 0 0', fontSize: 11, color: '#94a3b8', wordBreak: 'break-word' }}>{detalhe}</p>
        </div>
      </div>
    );
  }
}
